import $ from 'jquery';
import 'bootstrap/js/dist/tab';
import CheckOut from '../../components/checkout';
import QuantityInput from '../../components/quantity-input';
import AjaxFormWithHtmlResponse from './components/ajax-form-with-html-response';
import FormValidate from '../../components/form-validate';
import RadioInputDescription from './components/radio-input-description';
import AddressSelect from '../../components/address-select';
import ListAjaxFilter from './components/list-ajax-filter';
import RadioInputsBind from './components/radio-inputs-bind';
import StickyBar from '../../components/sticky-bar';
import RevealWhenVisible from '../../components/reveal-when-visible';
import RelatedProductsSlider from '../../components/related-products-slider';
import ProductColorSelect from '../../components/product-color-select';
import GiftCartValidation from './components/gift-cart-validation';
import CheckoutMessage from '../../components/checkout-message';
$(() => {
    QuantityInput.init();
    CheckOut.init();
    const resellersFilter = new ListAjaxFilter('.js__resellers-ajax-filter', '.js__radio-input-with-description', '.js__checkout-wrapper', '.js__no-reseller-message', true);
    new AjaxFormWithHtmlResponse('.js__coupon-ajax-content', () => {
        FormValidate.init();
        resellersFilter.filterList();
    });
    RadioInputsBind.init();
    RadioInputDescription.init();
    AddressSelect.init();
    StickyBar.init();
    RevealWhenVisible.init();
    RelatedProductsSlider.init();
    ProductColorSelect.init();
    GiftCartValidation.init();
    CheckoutMessage.init();
});
